var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMitekCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("title", {
    stroke: "null"
  }, "Employee ID"), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(307.43 -9.95)",
    d: "m149.92736,431.84307l-8.7057,-93.04012a9.08512,9.08512 0 0 1 2.13056,-6.67104l43.43262,-52.39683a11.25737,11.25737 0 0 1 4.51963,-3.23128a12.92513,12.92513 0 0 1 5.76211,-0.88391l148.69324,11.44917a12.39145,12.39145 0 0 1 6.39169,2.30985a9.919,9.919 0 0 1 3.68158,5.11168l20.43005,68.56158a8.75574,8.75574 0 0 1 -0.03752,5.1367l-19.98809,63.87518l-206.31015,-0.22098z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(307.43 -9.95)",
    d: "m456.14046,307.97442l-203.62923,0c-1.9888,0 -3.59819,0.80469 -3.59819,1.80118l0,147.17975c0,0.99649 1.60939,1.80118 3.59819,1.80118l203.62923,0c1.98463,0 3.59819,-0.80469 3.59819,-1.80118l0,-147.17975c0,-0.99649 -1.61356,-1.80118 -3.59819,-1.80118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m252.94485,307.97442l203.62506,0a3.60236,3.60236 0 0 1 3.59819,3.59819l0,23.60296l-210.82978,0l0,-23.60296a3.63988,3.63988 0 0 1 0.27518,-1.38007a3.61904,3.61904 0 0 1 1.95128,-1.94711a3.64822,3.64822 0 0 1 1.38007,-0.27101z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m460.16393,328.37946l-210.82561,0l0,1.70111l210.82561,0l0,-1.70111z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m453.15101,308.18706l3.2021,0a5.858,5.858 0 0 1 2.54333,0.52534c0.67544,0.33772 1.05486,0.79636 1.05486,1.25082l0,147.00047a1.06737,1.06737 0 0 1 -0.27518,0.68795a2.3974,2.3974 0 0 1 -0.77968,0.58372a4.67806,4.67806 0 0 1 -1.16743,0.38775a6.72524,6.72524 0 0 1 -1.3759,0.13759l-3.2021,0l0,-150.57364z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(307.43 -9.95)",
    d: "m451.89185,307.97442l-203.62923,0c-1.98463,0 -3.59819,0.80469 -3.59819,1.80118l0,147.17975c0,0.99649 1.61356,1.80118 3.59819,1.80118l203.62923,0c1.9888,0 3.59819,-0.80469 3.59819,-1.80118l0,-147.17975c0,-0.99649 -1.60939,-1.80118 -3.59819,-1.80118z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m248.04998,307.76178l203.8377,0a3.60236,3.60236 0 0 1 3.59819,3.59819l0,23.8156l-211.03408,0l0,-23.81977a3.59402,3.59402 0 0 1 3.59819,-3.59402z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m248.04998,307.76178l203.8377,0a3.60236,3.60236 0 0 1 3.59819,3.59819l0,23.8156l-211.03408,0l0,-23.81977a3.59402,3.59402 0 0 1 3.59819,-3.59402z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m307.99341,351.54463l-43.15327,0l0,52.49272l43.15327,0l0,-52.49272z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m434.87237,350.25212l-105.40655,0l0,3.40223l105.40655,0l0,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m357.93863,363.01882l-28.47282,0l0,3.40223l28.47699,0l-0.00417,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m434.87237,369.39383l-105.40655,0l0,3.40223l105.40655,0l0,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m367.29059,407.22277l-37.40784,0l0,3.40223l37.40367,0l0.00417,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m434.87237,425.92669l-37.40367,0l0,3.40223l37.40367,0l0,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m429.34791,431.87642l-26.35477,0l0,3.40223l26.35477,0l0,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m435.29764,413.60195l-105.41489,0l0,3.40223l105.41489,0l0,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m357.93863,381.72274l-28.47282,0l0,3.40223l28.47699,0l-0.00417,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m434.87237,388.09775l-105.40655,0l0,3.40223l105.40655,0l0,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m434.87237,394.47275l-105.40655,0l0,3.40223l105.40655,0l0,-3.40223z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m327.16014,299.04774"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m266.87064,412.13016l-1.53434,0l0,11.02389l1.53434,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m269.84342,412.13016l-2.35571,0l0,11.02389l2.35571,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m271.09424,412.13016l-0.7088,0l0,11.02389l0.7088,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m272.60356,412.13016l-0.7088,0l0,11.02389l0.7088,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m274.90924,412.13016l-1.53434,0l0,11.02389l1.53434,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m277.88202,412.13016l-2.35571,0l0,11.02389l2.35571,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m279.11199,412.13016l-0.7088,0l0,11.02389l0.7088,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m280.64216,412.13016l-0.7088,0l0,11.02389l0.7088,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m287.24649,423.15404l1.53434,0l0,-11.02389l-1.53434,0l0,11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m284.27371,423.15404l2.35571,0l0,-11.02389l-2.35571,0l0,11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m283.04374,423.15404l0.7088,0l0,-11.02389l-0.7088,0l0,11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m281.51774,423.15404l0.7088,0l0,-11.02389l-0.7088,0l0,11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m291.10735,412.13016l-1.53434,0l0,11.02389l1.53434,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m294.0843,412.13016l-2.35571,0l0,11.02389l2.35571,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m295.31427,412.13016l-0.7088,0l0,11.02389l0.7088,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m296.84444,412.13016l-0.7088,0l0,11.02389l0.7088,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m299.15012,412.13016l-1.53434,0l0,11.02389l1.53434,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m302.1229,412.13016l-2.35571,0l0,11.02389l2.35571,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m303.35287,412.13016l-0.7088,0l0,11.02389l0.7088,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m304.86636,412.13016l-0.7088,0l0,11.02389l0.7088,0l0,-11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m307.28878,423.15404l0.7088,0l0,-11.02389l-0.7088,0l0,11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#61656d",
    transform: "translate(307.43 -9.95)",
    d: "m305.75445,423.15404l0.7088,0l0,-11.02389l-0.7088,0l0,11.02389z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m286.6044,385.7337l-0.79636,1.4176l-4.2236,-4.35285l-0.08339,-0.07505l-10.34011,1.80535a7.1797,7.1797 0 0 0 -5.76628,5.47859l-0.54202,2.38073l0,11.6493l6.46674,0l1.73864,-9.673a0.24599,0.24599 0 0 1 0.41694,-0.17095a0.24599,0.24599 0 0 1 0.07922,0.17095l-0.17095,9.673l12.50819,0l1.04652,-17.96594a3.3105,3.3105 0 0 1 -0.34606,-0.33772l0.01251,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m303.99496,384.47037l-9.77307,-1.88457l-0.14176,0.14176l-3.70659,4.42373l-0.88808,-1.4176c-0.0959,0.11257 -0.18762,0.21264 -0.27935,0.30437l0.02502,0.39192l1.45929,17.60737l10.84043,0l0.37942,-9.91066l1.66776,4.32784l0,-0.06671l2.04717,5.64953l2.35571,0l0,-17.28632a7.18387,7.18387 0 0 0 -3.98594,-2.28066z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m287.55085,378.48311a4.58634,4.58634 0 0 1 -1.66776,-0.17095a4.43207,4.43207 0 0 0 1.66776,0.19596l0.47531,-0.06671c2.1806,-0.3544 3.44392,-2.10972 4.06516,-4.23611c-0.6671,2.24731 -1.99714,4.10686 -4.54047,4.2778z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m285.57456,378.21627l0.25016,0.0959c-0.08756,-0.02919 -0.16678,-0.06254 -0.25016,-0.0959z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m287.96779,383.06945l0.02919,0l4.90738,-2.7518l0,0.02919l-0.37942,-2.7935a5.37435,5.37435 0 0 1 -3.78998,1.07987a4.88653,4.88653 0 0 1 -1.15492,0.22515c-1.8804,0.13759 -3.44392,-0.72548 -4.62386,-2.58503a0.20847,0.20847 0 0 1 -0.02085,-0.0542a0.14176,0.14176 0 0 1 0,-0.05837a0.12925,0.12925 0 0 1 0,-0.05003a0.11674,0.11674 0 0 1 0.04169,-0.03752a0.09173,0.09173 0 0 1 0.06671,0a10.57776,10.57776 0 0 1 -0.72548,-1.35505l0.04169,5.76628l5.60784,2.58503z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m283.21885,376.10239a5.18256,5.18256 0 0 0 2.35571,2.11805c0.08339,0.03336 0.16261,0.06671 0.25016,0.0959l0.05837,0a4.58634,4.58634 0 0 0 1.66776,0.17095c2.55167,-0.18762 3.88171,-2.04717 4.54464,-4.29448a13.71732,13.71732 0 0 0 0.45446,-2.28066l-0.05837,0l-0.11257,-2.50164a0.28769,0.28769 0 0 1 -0.11257,-0.16678l-0.16261,-1.1174a0.83388,0.83388 0 0 1 -0.56704,-0.22098a0.83388,0.83388 0 0 1 -0.26684,-0.54202l-0.3002,-3.24796a3.38972,3.38972 0 0 1 -1.19245,0.34606l-6.67104,0.56704a1.0215,1.0215 0 0 0 -0.67961,0.34189a1.03818,1.03818 0 0 0 -0.25016,0.72131l0.11257,2.13473a0.52951,0.52951 0 0 1 -0.12091,0.38775a0.56704,0.56704 0 0 1 -0.3544,0.20013l-0.10423,0l0.03752,1.14658a0.28769,0.28769 0 0 1 -0.06254,0.20013a0.3002,0.3002 0 0 1 -0.18345,0.1084l0.25016,2.43076l-0.06671,0a15.98964,15.98964 0 0 0 0.70046,1.9346a10.57776,10.57776 0 0 0 0.72548,1.35505a0.17511,0.17511 0 0 1 0.07088,0.04169a0.16261,0.16261 0 0 1 0.03752,0.07088zm5.66204,-1.66776a1.63857,1.63857 0 0 1 -1.44261,1.19245a1.64274,1.64274 0 0 1 -1.61773,-0.94645l0,-0.02085a0.25433,0.25433 0 0 1 -0.02085,-0.05003a0.20847,0.20847 0 0 1 0,-0.05003a0.10423,0.10423 0 0 1 0.03336,-0.04169a0.08756,0.08756 0 0 1 0.04586,0l2.88105,-0.2043l0.04586,0l0.04169,0.02919a0.12925,0.12925 0 0 1 0,0.04169a0.10423,0.10423 0 0 1 0,0.05003l0.03336,0zm-1.56352,-1.20079l0.47531,-0.04586a0.18345,0.18345 0 0 1 0.12091,0.04586a0.16678,0.16678 0 0 1 0.05837,0.11257a0.15844,0.15844 0 0 1 -0.04169,0.12091a0.16261,0.16261 0 0 1 -0.11674,0.06254l-0.47531,0.04586a0.6671,0.6671 0 0 1 -0.27101,-0.03336a0.62958,0.62958 0 0 1 -0.23349,-0.13759a0.58372,0.58372 0 0 1 -0.15844,-0.21681a0.67127,0.67127 0 0 1 -0.05837,-0.26684a0.59622,0.59622 0 0 1 0.02502,-0.27101a0.67961,0.67961 0 0 1 0.12925,-0.24183a0.64209,0.64209 0 0 1 0.21264,-0.16678a0.65043,0.65043 0 0 1 0.26267,-0.07088a0.15844,0.15844 0 0 1 0.12091,0.04169a0.16261,0.16261 0 0 1 0.06254,0.11674a0.15844,0.15844 0 0 1 -0.04169,0.12091a0.16261,0.16261 0 0 1 -0.11674,0.06254a0.34606,0.34606 0 0 0 -0.14593,0.02502a0.5045,0.5045 0 0 0 -0.12508,0.08339a0.41694,0.41694 0 0 0 -0.07922,0.12925a0.34606,0.34606 0 0 0 0,0.14593a0.36691,0.36691 0 0 0 0.04169,0.14593a0.34189,0.34189 0 0 0 0.09173,0.11257a0.37525,0.37525 0 0 0 0.13342,0.07088a0.36691,0.36691 0 0 0 0.1501,0l-0.02085,0.00834zm-5.18673,-2.34737l-0.04169,-0.6546a0.90476,0.90476 0 0 1 0.03752,-0.33355a0.87557,0.87557 0 0 1 0.16261,-0.29186a0.90893,0.90893 0 0 1 0.26684,-0.2043a0.88808,0.88808 0 0 1 0.32521,-0.07922l2.87688,-0.15844l0.02502,0l2.24314,-0.13342l0.34189,-0.02502l2.56001,-0.13342a0.83388,0.83388 0 0 1 0.33772,0.04586a0.92561,0.92561 0 0 1 0.29603,0.17511a0.95062,0.95062 0 0 1 0.20013,0.27935a0.90476,0.90476 0 0 1 0.07505,0.33355l0.04586,0.65876a2.30568,2.30568 0 0 1 -4.58634,0.24599l-0.04586,-0.6546a0.83388,0.83388 0 0 1 0.13759,-0.52117l-0.88391,0.04586a0.83388,0.83388 0 0 1 0.20013,0.49616l0.04586,0.65876a2.30568,2.30568 0 0 1 -4.58634,0.24599l-0.03336,0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m287.60923,369.91083l0.04586,0.6546a1.95128,1.95128 0 0 0 3.89839,-0.22515l-0.02502,-0.6546a0.52534,0.52534 0 0 0 -0.17511,-0.34606a0.53368,0.53368 0 0 0 -0.36691,-0.12925l-2.56418,0.13759l-0.33772,0a0.52117,0.52117 0 0 0 -0.47531,0.56287zm1.70111,1.11323a0.59622,0.59622 0 0 1 -0.32521,-0.10007a0.60456,0.60456 0 0 1 -0.21681,-0.26267a0.59622,0.59622 0 0 1 -0.03336,-0.34189a0.60039,0.60039 0 0 1 0.4628,-0.4628a0.62541,0.62541 0 0 1 0.33772,0.03336a0.59205,0.59205 0 0 1 0.36274,0.54619a0.56704,0.56704 0 0 1 -0.17095,0.41694a0.54619,0.54619 0 0 1 -0.19179,0.12508a0.58789,0.58789 0 0 1 -0.22515,0.04586z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m284.5739,372.69599a1.96796,1.96796 0 0 0 0.73798,-0.18762a1.93877,1.93877 0 0 0 0.60873,-0.45863a2.02216,2.02216 0 0 0 0.38775,-0.65876a1.9346,1.9346 0 0 0 0.10007,-0.75466l-0.04586,-0.65876a0.41694,0.41694 0 0 0 -0.04169,-0.19179a0.43779,0.43779 0 0 0 -0.11257,-0.16261a0.52951,0.52951 0 0 0 -0.17095,-0.0959a0.44613,0.44613 0 0 0 -0.19596,0l-0.02502,0l-2.87688,0.15844a0.52534,0.52534 0 0 0 -0.34606,0.17511a0.53368,0.53368 0 0 0 -0.12925,0.36691l0.04586,0.6546a1.91375,1.91375 0 0 0 0.65043,1.34672a1.90125,1.90125 0 0 0 0.65876,0.38358a1.92626,1.92626 0 0 0 0.75466,0.08339zm0.2043,-1.33421a0.59622,0.59622 0 0 1 -0.32521,-0.10007a0.57538,0.57538 0 0 1 -0.21681,-0.26267a0.56287,0.56287 0 0 1 -0.03336,-0.34189a0.60039,0.60039 0 0 1 0.15844,-0.3002a0.60873,0.60873 0 0 1 0.3002,-0.16261a0.63375,0.63375 0 0 1 0.34189,0.03336a0.58789,0.58789 0 0 1 0.19179,0.95896a0.59205,0.59205 0 0 1 -0.41694,0.17511z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m292.62084,377.48246l-0.50033,-3.37721c0,0.03752 -0.02085,0.07922 -0.03336,0.11674l0.45029,3.33552l0.08339,-0.07505z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m288.022,378.4581l-0.47531,0.06671a4.43207,4.43207 0 0 1 -1.66776,-0.19596l-0.05837,0l-0.25016,-0.0959a5.18256,5.18256 0 0 1 -2.35571,-2.11805a0.13759,0.13759 0 0 0 -0.05837,-0.05003a0.12925,0.12925 0 0 0 -0.07922,0a0.09173,0.09173 0 0 0 -0.06671,0a0.11674,0.11674 0 0 0 -0.04169,0.03752a0.12925,0.12925 0 0 0 -0.02085,0.05003a0.14176,0.14176 0 0 0 0,0.05837a0.20847,0.20847 0 0 0 0.02085,0.0542c1.17994,1.85955 2.74346,2.72262 4.62386,2.58503a4.88653,4.88653 0 0 0 1.15492,-0.22515a5.37435,5.37435 0 0 0 3.78998,-1.07987l-0.45029,-3.33552c-0.62124,2.1389 -1.88457,3.89422 -4.06516,4.24862z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m288.022,378.4581l-0.47531,0.06671a4.43207,4.43207 0 0 1 -1.66776,-0.19596l-0.05837,0l-0.25016,-0.0959a5.18256,5.18256 0 0 1 -2.35571,-2.11805a0.13759,0.13759 0 0 0 -0.05837,-0.05003a0.12925,0.12925 0 0 0 -0.07922,0a0.09173,0.09173 0 0 0 -0.06671,0a0.11674,0.11674 0 0 0 -0.04169,0.03752a0.12925,0.12925 0 0 0 -0.02085,0.05003a0.14176,0.14176 0 0 0 0,0.05837a0.20847,0.20847 0 0 0 0.02085,0.0542c1.17994,1.85955 2.74346,2.72262 4.62386,2.58503a4.88653,4.88653 0 0 0 1.15492,-0.22515a5.37435,5.37435 0 0 0 3.78998,-1.07987l-0.45029,-3.33552c-0.62124,2.1389 -1.88457,3.89422 -4.06516,4.24862z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m290.95725,364.14872l0.3002,3.24796a0.83388,0.83388 0 0 0 0.27101,0.54202a0.83388,0.83388 0 0 0 0.56287,0.22098l-0.1501,-0.89642l0.83388,0l0.02502,0.70463a1.03818,1.03818 0 0 1 0.41694,-0.18345a1.02567,1.02567 0 0 1 0.45029,0c0.37108,-0.76717 0.94228,-2.33903 0.32521,-3.815c-0.44613,-1.0757 -1.11323,-1.40509 -1.72196,-1.43427a2.50164,2.50164 0 0 1 -1.33004,1.60522l0.01668,0.00834z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m280.92151,368.82262l-0.1084,-0.74632l0.83388,0.02502l0.02502,0.75466l0.10423,0a0.55453,0.55453 0 0 0 0.3544,-0.20013a0.52951,0.52951 0 0 0 0.12091,-0.38775l-0.11257,-2.13473a1.03818,1.03818 0 0 1 0.25016,-0.72131a1.0215,1.0215 0 0 1 0.67961,-0.34189l6.67104,-0.56704a3.38972,3.38972 0 0 0 1.19245,-0.34606a2.50164,2.50164 0 0 0 0.83388,-0.64626a2.50164,2.50164 0 0 0 0.49616,-0.93811a3.07285,3.07285 0 0 0 0.0959,-1.0632c-0.08339,-1.19662 -1.05903,-2.21812 -2.58503,-2.32652l-1.18828,-0.08756c-2.85604,-0.23766 -4.44875,0.02919 -6.57931,0.80469c-3.64822,1.32587 -3.80249,6.79195 -2.1806,8.84329a1.0757,1.0757 0 0 1 0.5587,-0.10007a1.05486,1.05486 0 0 1 0.52951,0.20013l0.00834,-0.02085z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m281.47187,370.31109l-0.02502,0a0.31687,0.31687 0 0 1 -0.21264,-0.05003a0.29603,0.29603 0 0 1 -0.12508,-0.17511l-0.18762,-1.25082a1.0632,1.0632 0 0 0 -0.51701,-0.19596a1.02567,1.02567 0 0 0 -0.54619,0.08756a1.15909,1.15909 0 0 0 -0.24599,0.15427l-0.02085,0c-1.14658,0.99232 -0.41694,4.06516 2.0847,3.85669l0.03752,0l-0.24183,-2.42659zm-0.70463,0.93811a0.20847,0.20847 0 0 1 -0.12091,-0.05003a0.19179,0.19179 0 0 1 -0.06254,-0.1084l-0.04586,-0.36274a1.25082,1.25082 0 0 0 -0.3127,-0.79219a0.36274,0.36274 0 0 0 -0.12925,-0.07505a0.34189,0.34189 0 0 0 -0.14593,0a0.17511,0.17511 0 0 1 -0.12925,-0.02919a0.17095,0.17095 0 0 1 -0.07088,-0.1084a0.17928,0.17928 0 0 1 0,-0.06671a0.14176,0.14176 0 0 1 0.02502,-0.06254a0.15844,0.15844 0 0 1 0.04586,-0.04586a0.19596,0.19596 0 0 1 0.06254,-0.02502a0.77968,0.77968 0 0 1 0.54202,0.13342a1.41343,1.41343 0 0 1 0.33355,0.4628a1.35922,1.35922 0 0 1 0.12091,0.5587l0.04586,0.36274a0.23349,0.23349 0 0 1 -0.04169,0.13759a0.24183,0.24183 0 0 1 -0.11674,0.08756l0,-0.01668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m292.82931,367.98874l0.03752,1.20079a0.3002,0.3002 0 0 1 -0.27101,0.31687a0.36274,0.36274 0 0 1 -0.23766,-0.07505l0.11257,2.50164l0.07088,0c2.50164,-0.13759 2.74346,-3.15206 1.48431,-3.96093l0,0a1.02984,1.02984 0 0 0 -0.30437,-0.12925a1.04652,1.04652 0 0 0 -0.45446,-0.02919a1.0632,1.0632 0 0 0 -0.41694,0.16261l-0.02085,0.01251zm1.21329,0.67544a0.17928,0.17928 0 0 1 -0.06254,0.1084a0.19596,0.19596 0 0 1 -0.11674,0.05003a0.30854,0.30854 0 0 0 -0.1501,0.03752a0.3544,0.3544 0 0 0 -0.12091,0.10007a1.0632,1.0632 0 0 0 -0.19179,0.39609a1.10489,1.10489 0 0 0 0,0.43779l0,0.35023a0.15844,0.15844 0 0 1 -0.04169,0.12091a0.16261,0.16261 0 0 1 -0.11674,0.06254c-0.11257,0 -0.17928,-0.06671 -0.13342,-0.15844l0,-0.36274a1.40926,1.40926 0 0 1 0.02919,-0.57538a1.39675,1.39675 0 0 1 0.26267,-0.51284a0.66293,0.66293 0 0 1 0.22515,-0.16261a0.6129,0.6129 0 0 1 0.27101,-0.06254a0.16678,0.16678 0 0 1 0.1084,0.05837a0.18762,0.18762 0 0 1 0.05003,0.11257l-0.01251,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m280.81311,368.05962l0.1084,0.74632l0.18762,1.25082a0.3127,0.3127 0 0 0 0.12508,0.17511a0.31687,0.31687 0 0 0 0.21264,0.05003l0.02502,0a0.3002,0.3002 0 0 0 0.18345,-0.1084a0.28769,0.28769 0 0 0 0.06254,-0.20013l-0.03752,-1.14658l-0.02502,-0.75466l-0.84222,-0.01251z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m292.86684,369.18952l-0.03752,-1.20079l-0.02502,-0.70463l-0.83388,0l0.13342,0.89642l0.16261,1.1174a0.30854,0.30854 0 0 0 0.11257,0.16678a0.36274,0.36274 0 0 0 0.22515,0.06254a0.2585,0.2585 0 0 0 0.11257,-0.03752a0.27935,0.27935 0 0 0 0.09173,-0.07922a0.24183,0.24183 0 0 0 0.05003,-0.10423a0.22515,0.22515 0 0 0 0,-0.11674l0.00834,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m284.7782,370.18601a0.56704,0.56704 0 0 0 -0.32521,0.10007a0.58372,0.58372 0 0 0 -0.25016,0.60039a0.60039,0.60039 0 0 0 0.4628,0.4628a0.58789,0.58789 0 0 0 0.33772,-0.03336a0.61707,0.61707 0 0 0 0.26684,-0.21681a0.58789,0.58789 0 0 0 -0.49199,-0.9131zm-0.27101,0.6546l-0.05003,0a0.17095,0.17095 0 0 1 -0.04586,-0.02919a0.1084,0.1084 0 0 1 -0.02919,-0.04586a0.11257,0.11257 0 0 1 0,-0.05003a0.15427,0.15427 0 0 1 0.04169,-0.10007a0.13759,0.13759 0 0 1 0.0959,-0.03752l0.0542,0l0.04169,0.02919a0.14176,0.14176 0 0 1 0.02919,0.04586a0.11257,0.11257 0 0 1 0,0.0542a0.12925,0.12925 0 0 1 -0.03752,0.09173a0.13759,0.13759 0 0 1 -0.0959,0.04169l-0.00417,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m284.50719,370.56126a0.13759,0.13759 0 0 0 -0.0959,0.03752a0.15427,0.15427 0 0 0 -0.04169,0.10007a0.11257,0.11257 0 0 0 0,0.05003a0.1084,0.1084 0 0 0 0.02919,0.04586a0.17095,0.17095 0 0 0 0.04586,0.02919l0.05003,0a0.13759,0.13759 0 0 0 0.0959,-0.04169a0.12925,0.12925 0 0 0 0.03752,-0.09173a0.11257,0.11257 0 0 0 0,-0.0542a0.14176,0.14176 0 0 0 -0.02919,-0.04586l-0.04169,-0.02919l-0.05003,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m289.31034,369.84829a0.56704,0.56704 0 0 0 -0.32521,0.10007a0.53368,0.53368 0 0 0 -0.21681,0.26267a0.55453,0.55453 0 0 0 -0.03336,0.33772a0.58372,0.58372 0 0 0 0.4628,0.4628a0.58372,0.58372 0 0 0 0.60039,-0.25016a0.56704,0.56704 0 0 0 0.10007,-0.32521a0.58372,0.58372 0 0 0 -0.04169,-0.22515a0.55453,0.55453 0 0 0 -0.12925,-0.19179a0.60039,0.60039 0 0 0 -0.19179,-0.12925a0.58372,0.58372 0 0 0 -0.22515,-0.04169zm-0.27101,0.67544a0.13759,0.13759 0 0 1 -0.0959,-0.04169a0.12091,0.12091 0 0 1 -0.04169,-0.0959a0.12925,0.12925 0 0 1 0.04586,-0.08339a0.14593,0.14593 0 0 1 0.07505,-0.03752a0.14176,0.14176 0 0 1 0.08756,0.03336a0.12925,0.12925 0 0 1 0.04586,0.08339a0.13759,0.13759 0 0 1 -0.03752,0.0959a0.15427,0.15427 0 0 1 -0.0959,0.04169l0.01668,0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m289.02265,370.26523a0.10423,0.10423 0 0 0 -0.05003,0a0.1084,0.1084 0 0 0 -0.04586,0.02919a0.0959,0.0959 0 0 0 -0.02919,0.04169a0.11674,0.11674 0 0 0 0,0.0542a0.0959,0.0959 0 0 0 0,0.05837a0.12925,0.12925 0 0 0 0.02502,0.0542a0.1501,0.1501 0 0 0 0.05003,0.03336a0.13342,0.13342 0 0 0 0.05837,0l0.05837,0l0.04586,-0.03336a0.12925,0.12925 0 0 0 0.02502,-0.0542a0.0959,0.0959 0 0 0 0,-0.05837a0.12925,0.12925 0 0 0 -0.13759,-0.12508z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m287.2715,372.50003a0.16261,0.16261 0 0 0 0.11674,-0.06254a0.15844,0.15844 0 0 0 0.04169,-0.12091a0.17095,0.17095 0 0 0 -0.18345,-0.15844a0.65043,0.65043 0 0 0 -0.26267,0.07088a0.68795,0.68795 0 0 0 -0.21264,0.16678a0.67961,0.67961 0 0 0 -0.12925,0.24183a0.74215,0.74215 0 0 0 -0.02502,0.27101a0.67127,0.67127 0 0 0 0.05837,0.26684a0.6671,0.6671 0 0 0 0.39192,0.3544a0.6671,0.6671 0 0 0 0.27101,0.03336l0.47531,-0.04586a0.16261,0.16261 0 0 0 0.11674,-0.06254a0.15844,0.15844 0 0 0 0.04169,-0.12091a0.16678,0.16678 0 0 0 -0.05837,-0.11257a0.18345,0.18345 0 0 0 -0.12091,-0.04586l-0.47531,0.04586a0.36691,0.36691 0 0 1 -0.1501,0a0.32938,0.32938 0 0 1 -0.12925,-0.07088a0.30854,0.30854 0 0 1 -0.0959,-0.11257a0.36691,0.36691 0 0 1 -0.04169,-0.14593a0.41694,0.41694 0 0 1 0,-0.14593a0.51284,0.51284 0 0 1 0.07922,-0.12925a0.5045,0.5045 0 0 1 0.12508,-0.08339a0.34606,0.34606 0 0 1 0.16678,-0.03336z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m287.2715,372.50003a0.16261,0.16261 0 0 0 0.11674,-0.06254a0.15844,0.15844 0 0 0 0.04169,-0.12091a0.17095,0.17095 0 0 0 -0.18345,-0.15844a0.65043,0.65043 0 0 0 -0.26267,0.07088a0.68795,0.68795 0 0 0 -0.21264,0.16678a0.67961,0.67961 0 0 0 -0.12925,0.24183a0.74215,0.74215 0 0 0 -0.02502,0.27101a0.67127,0.67127 0 0 0 0.05837,0.26684a0.6671,0.6671 0 0 0 0.39192,0.3544a0.6671,0.6671 0 0 0 0.27101,0.03336l0.47531,-0.04586a0.16261,0.16261 0 0 0 0.11674,-0.06254a0.15844,0.15844 0 0 0 0.04169,-0.12091a0.16678,0.16678 0 0 0 -0.05837,-0.11257a0.18345,0.18345 0 0 0 -0.12091,-0.04586l-0.47531,0.04586a0.36691,0.36691 0 0 1 -0.1501,0a0.32938,0.32938 0 0 1 -0.12925,-0.07088a0.30854,0.30854 0 0 1 -0.0959,-0.11257a0.36691,0.36691 0 0 1 -0.04169,-0.14593a0.41694,0.41694 0 0 1 0,-0.14593a0.51284,0.51284 0 0 1 0.07922,-0.12925a0.5045,0.5045 0 0 1 0.12508,-0.08339a0.34606,0.34606 0 0 1 0.16678,-0.03336z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m284.56973,373.0629a2.31819,2.31819 0 0 0 0.8714,-0.22098a2.32235,2.32235 0 0 0 1.17994,-1.31336a2.29734,2.29734 0 0 0 0.12508,-0.88808l-0.02919,-0.66293a0.80886,0.80886 0 0 0 -0.20013,-0.49616l0.88391,-0.04586a0.83388,0.83388 0 0 0 -0.13759,0.52117l0.04586,0.6546a2.30568,2.30568 0 0 0 4.58634,-0.24599l-0.04586,-0.65876a0.83388,0.83388 0 0 0 -0.07505,-0.33355a0.83388,0.83388 0 0 0 -0.49616,-0.45446a0.83388,0.83388 0 0 0 -0.33772,-0.04586l-2.56001,0.13342l-0.34189,0.02502l-2.24314,0.13342l-0.02502,0l-2.87688,0.15844a0.88808,0.88808 0 0 0 -0.32521,0.07922a0.83388,0.83388 0 0 0 -0.26267,0.2043a0.83388,0.83388 0 0 0 -0.16678,0.29186a0.90476,0.90476 0 0 0 -0.03752,0.33355l0.04169,0.6546a2.30985,2.30985 0 0 0 2.42659,2.17643zm3.5148,-3.68992l0.33772,0l2.56418,-0.13759a0.53368,0.53368 0 0 1 0.36691,0.12925a0.52534,0.52534 0 0 1 0.17511,0.34606l0.02502,0.6546a1.95128,1.95128 0 0 1 -3.89839,0.22515l-0.04586,-0.6546a0.5587,0.5587 0 0 1 0.02085,-0.2043a0.50867,0.50867 0 0 1 0.10007,-0.17928a0.47948,0.47948 0 0 1 0.15844,-0.12925a0.55036,0.55036 0 0 1 0.19596,-0.0542l0,0.00417zm-5.62035,0.83388a0.53368,0.53368 0 0 1 0.12925,-0.36691a0.52534,0.52534 0 0 1 0.34606,-0.17511l2.87688,-0.15844l0.02502,0a0.44613,0.44613 0 0 1 0.19596,0a0.52951,0.52951 0 0 1 0.17095,0.0959a0.5045,0.5045 0 0 1 0.11674,0.16261a0.49199,0.49199 0 0 1 0.03752,0.19179l0.04586,0.65876a1.95128,1.95128 0 0 1 -3.89839,0.22515l-0.04586,-0.63375z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m288.76832,374.28453l-2.88105,0.2043a0.08756,0.08756 0 0 0 -0.04586,0a0.0959,0.0959 0 0 0 -0.02919,0.04169a0.07088,0.07088 0 0 0 0,0.05003a0.11674,0.11674 0 0 0 0,0.05003l0,0.02085a1.6344,1.6344 0 0 0 3.06034,-0.24599a0.10007,0.10007 0 0 0 0,-0.05003a0.15427,0.15427 0 0 0 -0.02085,-0.04586a0.10423,0.10423 0 0 0 -0.09173,-0.04169l0.00834,0.01668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m289.69392,385.47936c-0.07088,0.09173 -0.13759,0.17095 -0.20847,0.25433l0.88808,1.4176l3.70659,-4.42373l-3.70659,3.70243l-0.67961,-0.95062z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m289.69392,385.47936c-0.07088,0.09173 -0.13759,0.17095 -0.20847,0.25433l0.88808,1.4176l3.70659,-4.42373l-3.70659,3.70243l-0.67961,-0.95062z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m286.42095,385.47936l-0.6129,0.95062l-4.2236,-3.63155l4.2236,4.35285l0.79636,-1.4176c-0.06671,-0.08339 -0.12508,-0.16678 -0.18345,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m286.42095,385.47936l-0.6129,0.95062l-4.2236,-3.63155l4.2236,4.35285l0.79636,-1.4176c-0.06671,-0.08339 -0.12508,-0.16678 -0.18345,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m280.42535,369.63982a0.77968,0.77968 0 0 0 -0.54202,-0.13342a0.19596,0.19596 0 0 0 -0.06254,0.02502a0.15844,0.15844 0 0 0 -0.04586,0.04586a0.14176,0.14176 0 0 0 -0.02502,0.06254a0.16678,0.16678 0 0 0 0.07505,0.17511a0.17095,0.17095 0 0 0 0.12508,0.02919a0.37108,0.37108 0 0 1 0.1501,0a0.38358,0.38358 0 0 1 0.12508,0.07505a1.25082,1.25082 0 0 1 0.3127,0.79219l0.04586,0.36274a0.20013,0.20013 0 0 0 0.06671,0.1084a0.20847,0.20847 0 0 0 0.11674,0.05003a0.22515,0.22515 0 0 0 0.11674,-0.08756a0.20847,0.20847 0 0 0 0.04169,-0.13759l-0.04586,-0.36274a1.39675,1.39675 0 0 0 -0.45446,-1.0215l0,0.01668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m280.42535,369.63982a0.77968,0.77968 0 0 0 -0.54202,-0.13342a0.19596,0.19596 0 0 0 -0.06254,0.02502a0.15844,0.15844 0 0 0 -0.04586,0.04586a0.14176,0.14176 0 0 0 -0.02502,0.06254a0.16678,0.16678 0 0 0 0.07505,0.17511a0.17095,0.17095 0 0 0 0.12508,0.02919a0.37108,0.37108 0 0 1 0.1501,0a0.38358,0.38358 0 0 1 0.12508,0.07505a1.25082,1.25082 0 0 1 0.3127,0.79219l0.04586,0.36274a0.20013,0.20013 0 0 0 0.06671,0.1084a0.20847,0.20847 0 0 0 0.11674,0.05003a0.22515,0.22515 0 0 0 0.11674,-0.08756a0.20847,0.20847 0 0 0 0.04169,-0.13759l-0.04586,-0.36274a1.39675,1.39675 0 0 0 -0.45446,-1.0215l0,0.01668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(307.43 -9.95)",
    d: "m289.21861,386.42999l-1.25082,0.72131l-1.05903,-0.72131l0.04586,-0.33355l-0.02502,-0.02502l-1.04652,17.96594l4.80732,0l-1.4718,-17.60737z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m289.21861,386.42999l-0.02502,-0.39192l0.02502,0.39192z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m289.21861,386.42999l-0.02502,-0.39192l0.02502,0.39192z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(307.43 -9.95)",
    d: "m288.09288,386.79272a3.78164,3.78164 0 0 1 -1.13408,-0.69629l-0.04586,0.33355l1.05903,0.72131l1.25082,-0.72131l-0.03336,-0.38358a3.05617,3.05617 0 0 1 -1.09655,0.74632z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m288.09288,386.79272a3.78164,3.78164 0 0 1 -1.13408,-0.69629l-0.04586,0.33355l1.05903,0.72131l1.25082,-0.72131l-0.03336,-0.38358a3.05617,3.05617 0 0 1 -1.09655,0.74632z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(307.43 -9.95)",
    d: "m287.96362,383.06528l0,0l0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(307.43 -9.95)",
    d: "m287.96779,383.06945l-1.55102,2.41408c0.05837,0.08756 0.11674,0.17095 0.18345,0.25433a3.60653,3.60653 0 0 0 0.32938,0.33772l0.02502,0.02502a3.78164,3.78164 0 0 0 1.13408,0.69629a3.03532,3.03532 0 0 0 1.10489,-0.74632l0,0c0.09173,-0.09173 0.18345,-0.19179 0.27935,-0.30437s0.13759,-0.16261 0.20847,-0.25433l-1.71362,-2.42242z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m293.09615,369.79826l0,0.34606c-0.04586,0.09173 0.02085,0.15844 0.13342,0.15844a0.17095,0.17095 0 0 0 0.15844,-0.15844l0,-0.35857a1.10489,1.10489 0 0 1 0,-0.41694a1.0632,1.0632 0 0 1 0.19179,-0.41694a0.41694,0.41694 0 0 1 0.12091,-0.10007a0.32104,0.32104 0 0 1 0.1501,-0.03752l0.07505,0a0.18345,0.18345 0 0 0 0.06254,-0.03336a0.15427,0.15427 0 0 0 0.05003,-0.0542a0.20013,0.20013 0 0 0 0.02085,-0.07088a0.19596,0.19596 0 0 0 0,-0.07088a0.16678,0.16678 0 0 0 -0.04169,-0.06254a0.17511,0.17511 0 0 0 -0.05837,-0.03752a0.15427,0.15427 0 0 0 -0.07505,0a0.62958,0.62958 0 0 0 -0.27101,0.06254a0.66293,0.66293 0 0 0 -0.22515,0.16261a1.38007,1.38007 0 0 0 -0.26267,0.51701a1.42593,1.42593 0 0 0 -0.02919,0.57955l0,-0.00834z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m293.09615,369.79826l0,0.34606c-0.04586,0.09173 0.02085,0.15844 0.13342,0.15844a0.17095,0.17095 0 0 0 0.15844,-0.15844l0,-0.35857a1.10489,1.10489 0 0 1 0,-0.41694a1.0632,1.0632 0 0 1 0.19179,-0.41694a0.41694,0.41694 0 0 1 0.12091,-0.10007a0.32104,0.32104 0 0 1 0.1501,-0.03752l0.07505,0a0.18345,0.18345 0 0 0 0.06254,-0.03336a0.15427,0.15427 0 0 0 0.05003,-0.0542a0.20013,0.20013 0 0 0 0.02085,-0.07088a0.19596,0.19596 0 0 0 0,-0.07088a0.16678,0.16678 0 0 0 -0.04169,-0.06254a0.17511,0.17511 0 0 0 -0.05837,-0.03752a0.15427,0.15427 0 0 0 -0.07505,0a0.62958,0.62958 0 0 0 -0.27101,0.06254a0.66293,0.66293 0 0 0 -0.22515,0.16261a1.38007,1.38007 0 0 0 -0.26267,0.51701a1.42593,1.42593 0 0 0 -0.02919,0.57955l0,-0.00834z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m285.80805,386.42999l0.6129,-0.95479l1.55102,-2.40991l0,0l-5.56615,-2.61838l-0.0542,-0.02502l-0.86307,2.28483l0,0l0.08339,0.07505l4.23611,3.64822z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m273.30402,394.12669a0.24183,0.24183 0 0 0 -0.24599,0.23766l-1.73864,9.673l2.05551,0l0.17095,-9.673a0.25016,0.25016 0 0 0 -0.07505,-0.16678a0.22515,0.22515 0 0 0 -0.16678,-0.07088z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m273.30402,394.12669a0.24183,0.24183 0 0 0 -0.24599,0.23766l-1.73864,9.673l2.05551,0l0.17095,-9.673a0.25016,0.25016 0 0 0 -0.07505,-0.16678a0.22515,0.22515 0 0 0 -0.16678,-0.07088z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m301.91443,394.12669l-0.38358,9.91066l2.0847,0l0,-5.58282l-1.70111,-4.32784z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m301.91443,394.12669l-0.38358,9.91066l2.0847,0l0,-5.58282l-1.70111,-4.32784z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m287.99281,383.05277l0,0l1.72196,2.40991l0.67961,0.95479l3.70659,-3.70243l0.14176,-0.14176l-1.30502,-2.25564l0,-0.02919l-4.94491,2.76431z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m455.49004,328.37946l-210.82561,0l0,1.70111l210.82561,0l0,-1.70111z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m254.77939,413.28925l-13.38794,-35.28562a12.02454,12.02454 0 0 0 -8.98505,-7.56329l-16.41075,-3.16457l-21.19305,0.20013l-17.51147,3.06034a12.04956,12.04956 0 0 0 -9.69802,9.22271l-9.94818,43.72865a7.06296,7.06296 0 0 0 1.90541,6.44172l0,0a7.04628,7.04628 0 0 0 7.72589,1.50515l11.77021,-4.97826l-0.18762,14.53452a2.97695,2.97695 0 0 0 2.97695,2.97695l46.92658,0a2.97695,2.97695 0 0 0 2.97278,-2.97695l-0.15427,-11.91614l20.01311,-8.37215a5.83716,5.83716 0 0 0 3.18542,-7.41319zm-23.04009,2.83936l0,-22.31462l6.70022,18.39121l-6.70022,3.9234z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m203.78765,372.68765l-3.33552,56.15345l5.64953,10.08994l6.05397,-10.08994l-4.62803,-56.15345l-3.73995,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m203.72511,373.73417l1.77616,1.21329l2.11388,-1.21329l-0.0959,-1.61356l-3.63155,0.41694l-0.16261,1.19662z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m202.91207,372.13312a5.76211,5.76211 0 0 0 2.80184,2.20561s1.34672,-0.37942 2.69343,-2.20561l-2.04301,-4.36953l-1.45512,0.5045l-1.99714,3.86503z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(307.43 -9.95)",
    d: "m212.76853,395.93621l-0.60873,0l-13.44214,-17.92841c-3.90673,-5.14921 -5.42022,-9.09346 -4.51963,-11.72435a3.60653,3.60653 0 0 1 0.88391,-1.43427a3.64405,3.64405 0 0 1 1.43427,-0.87557l17.92841,0l0.1084,0.09173c4.93657,4.09018 2.32652,11.89946 2.21395,12.22884c-3.17291,7.14635 -3.6107,19.14171 -3.61487,19.26262l0,0.38775l-0.38358,-0.00834zm-16.08971,-31.16208a2.83102,2.83102 0 0 0 -1.72196,1.79284c-0.55036,1.62607 -0.23349,4.84484 4.40705,10.96135l13.0252,17.36971c0.13342,-2.59753 0.80052,-12.50819 3.64405,-18.90405c0,-0.04169 2.50164,-7.45905 -1.86789,-11.21985l-17.48646,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(307.43 -9.95)",
    d: "m213.80671,363.52331l-2.44744,-18.066l-15.33088,1.25082l0.11257,17.29466l9.3603,4.08184l8.30544,-4.56132z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(307.43 -9.95)",
    d: "m213.03954,338.95305s3.11871,20.62601 -8.25958,21.46406c-11.11145,0.83388 -11.45334,-20.01311 -11.45334,-20.01311l-0.30437,-5.97475l14.30937,-2.50164l3.61487,1.86372l2.09304,5.16171z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m213.30638,358.70766l-0.83388,-5.66621c-1.02567,3.65239 -3.15623,6.69605 -6.88785,7.30479l0.05003,0l-0.79636,0.11257c-2.96861,0.22932 -5.44106,-1.13825 -7.30895,-4.0735a0.24599,0.24599 0 0 0 -0.34189,-0.07505a0.24183,0.24183 0 0 0 -0.1084,0.15427a0.27101,0.27101 0 0 0 0.03336,0.18762c1.98046,3.11871 4.60718,4.58634 7.76342,4.34034a8.3388,8.3388 0 0 0 1.93877,-0.38358a9.07678,9.07678 0 0 0 6.50426,-1.90125l-0.01251,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m210.3336,334.35003s3.61904,-2.3974 5.32849,1.71362c1.44678,3.4606 -0.98815,7.22974 -0.98815,7.22974l-2.0847,-0.22932c-0.87557,-0.03752 -1.48848,-0.45446 -1.56352,-1.29251l-0.69212,-7.42153z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m206.58531,327.78323c0.66293,0.0542 1.33004,0.0959 1.99714,0.14593c2.56001,0.18762 4.19858,1.90125 4.34451,3.9109c0.30437,3.91923 -3.04366,4.94491 -4.41539,5.05748l-11.21568,0.95062a1.70945,1.70945 0 0 0 -1.13825,0.57955a1.73447,1.73447 0 0 0 -0.41694,1.20913l0.18762,3.58151a0.91727,0.91727 0 0 1 -0.79636,0.98815l-0.68378,0.07505l-0.77551,0.9673c-4.41539,-1.0632 -5.39103,-13.45465 1.86789,-16.09388c3.57734,-1.32587 6.2541,-1.77199 11.04474,-1.37173z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(307.43 -9.95)",
    d: "m194.46904,345.49901a1.8262,1.8262 0 0 0 -0.3544,-0.91727a1.84287,1.84287 0 0 0 -2.64757,-0.33355l-0.03752,0.03752c-1.94294,1.66776 -0.68378,6.92537 3.57734,6.47091l-0.53785,-5.25761z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(307.43 -9.95)",
    d: "m215.66626,342.72219l-0.03752,-0.03752a1.83454,1.83454 0 0 0 -0.94228,-0.25016a1.90541,1.90541 0 0 0 -0.93811,0.26267a1.86789,1.86789 0 0 0 -0.89642,1.66776l0.22515,5.00328c4.29865,-0.13759 4.71976,-5.27846 2.5892,-6.64602z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m194.99022,346.14526a0.50867,0.50867 0 0 1 -0.45446,0.53368a0.52117,0.52117 0 0 1 -0.57121,-0.37942l-0.49199,-3.38555l1.40926,0.03752l0.1084,3.19376z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m213.72332,344.7777a0.50867,0.50867 0 0 1 -0.11674,0.35857a0.52951,0.52951 0 0 1 -0.90893,-0.2043l-0.49199,-3.38555l1.40926,0.03752l0.1084,3.19376z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m200.13942,348.43009a0.99232,0.99232 0 0 0 0.55036,-0.16678a1.00066,1.00066 0 0 0 0.41694,-1.01316a0.98815,0.98815 0 0 0 -0.77968,-0.77968a1.00066,1.00066 0 0 0 -1.01316,0.41694a0.99232,0.99232 0 0 0 -0.09173,0.92978a0.9673,0.9673 0 0 0 0.53368,0.53368a0.99232,0.99232 0 0 0 0.37942,0.07505l0.00417,0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m199.68079,347.55452a0.24599,0.24599 0 0 0 0.16261,-0.06671a0.22932,0.22932 0 0 0 0.06671,-0.15844a0.24183,0.24183 0 0 0 0,-0.0959a0.22098,0.22098 0 0 0 -0.04586,-0.08756a0.27935,0.27935 0 0 0 -0.07922,-0.05837a0.24599,0.24599 0 0 0 -0.0959,0a0.24599,0.24599 0 0 0 -0.09173,0a0.27935,0.27935 0 0 0 -0.07922,0.05837a0.22098,0.22098 0 0 0 -0.04586,0.08756a0.24183,0.24183 0 0 0 0,0.0959a0.18762,0.18762 0 0 0 0,0.08339a0.23766,0.23766 0 0 0 0.05003,0.07505a0.27518,0.27518 0 0 0 0.07088,0.05003a0.32521,0.32521 0 0 0 0.08756,0.01668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m207.74858,347.85888a0.99232,0.99232 0 0 0 0.55036,-0.16678a0.97564,0.97564 0 0 0 0.36274,-0.44613a0.98815,0.98815 0 1 0 -1.90125,-0.37108a1.00482,1.00482 0 0 0 0.29186,0.69629a0.99232,0.99232 0 0 0 0.69629,0.28769z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m207.30245,347.02084a0.23349,0.23349 0 0 0 0.12925,-0.03752a0.28769,0.28769 0 0 0 0.08756,-0.10007a0.25016,0.25016 0 0 0 0,-0.13342a0.22515,0.22515 0 0 0 -0.06254,-0.12091a0.20013,0.20013 0 0 0 -0.11674,-0.06254a0.25016,0.25016 0 0 0 -0.13342,0a0.21681,0.21681 0 0 0 -0.10007,0.08339a0.20847,0.20847 0 0 0 -0.04169,0.12925a0.22932,0.22932 0 0 0 0.06671,0.15844a0.23349,0.23349 0 0 0 0.15844,0.07088l0.01251,0.01251z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m204.43807,352.12418l0.79636,-0.07505a0.36274,0.36274 0 0 0 0.11674,-0.02085a0.32521,0.32521 0 0 0 0.10007,-0.06671a0.25433,0.25433 0 0 0 0.06254,-0.10007a0.24599,0.24599 0 0 0 0,-0.12091a0.26684,0.26684 0 0 0 -0.02919,-0.11257a0.27935,0.27935 0 0 0 -0.07922,-0.09173a0.25016,0.25016 0 0 0 -0.10423,-0.0542a0.29603,0.29603 0 0 0 -0.12091,0l-0.79636,0.07505a0.69629,0.69629 0 0 1 -0.24599,-0.02085a0.64626,0.64626 0 0 1 -0.21681,-0.11674a0.6671,0.6671 0 0 1 -0.1501,-0.19179a0.70046,0.70046 0 0 1 -0.06671,-0.23766a0.62124,0.62124 0 0 1 0.03752,-0.24599a0.63375,0.63375 0 0 1 0.12508,-0.20847a0.67127,0.67127 0 0 1 0.20013,-0.14176a0.6129,0.6129 0 0 1 0.24183,-0.05003a0.36274,0.36274 0 0 0 0.11674,-0.02085a0.32521,0.32521 0 0 0 0.10007,-0.06671a0.25433,0.25433 0 0 0 0.06254,-0.10007a0.23766,0.23766 0 0 0 0,-0.12091a0.26684,0.26684 0 0 0 -0.02919,-0.11257a0.27935,0.27935 0 0 0 -0.07922,-0.09173a0.25016,0.25016 0 0 0 -0.10423,-0.0542a0.29603,0.29603 0 0 0 -0.12091,0a1.08821,1.08821 0 0 0 -0.44196,0.11674a1.11323,1.11323 0 0 0 -0.35857,0.27935a1.20496,1.20496 0 0 0 -0.21681,0.41694a1.21329,1.21329 0 0 0 0.3127,1.27584a1.15909,1.15909 0 0 0 0.39609,0.23349a1.14658,1.14658 0 0 0 0.45863,0.05003l0.03336,-0.02502z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m210.48787,344.24402l-4.30282,0.22515l-0.56704,0.03752l-3.75246,0.22932l-0.03752,0l-4.83233,0.26684a1.3759,1.3759 0 0 0 -0.54202,0.14176a1.45095,1.45095 0 0 0 -0.44196,0.33772a1.39258,1.39258 0 0 0 -0.27935,0.48782a1.46346,1.46346 0 0 0 -0.07088,0.55453l0.07922,1.10072a3.97344,3.97344 0 0 0 0.3544,1.48431a3.87337,3.87337 0 0 0 0.90476,1.25082a3.75246,3.75246 0 0 0 1.30502,0.78802a3.81917,3.81917 0 0 0 1.51349,0.22098a3.86503,3.86503 0 0 0 3.64822,-4.14021l-0.07505,-1.10072a1.3217,1.3217 0 0 0 -0.34189,-0.83388l1.48431,-0.07505a1.36756,1.36756 0 0 0 -0.22515,0.8714l0.07505,1.10072a3.85669,3.85669 0 0 0 1.28001,2.66841a3.81917,3.81917 0 0 0 1.30085,0.77134a3.8692,3.8692 0 0 0 4.1694,-1.0632a3.95676,3.95676 0 0 0 0.77134,-1.30085a3.87337,3.87337 0 0 0 0.21264,-1.49264l-0.07922,-1.10072a1.42176,1.42176 0 0 0 -0.12508,-0.57121a1.45512,1.45512 0 0 0 -0.34189,-0.47114a1.55935,1.55935 0 0 0 -0.50033,-0.29603a1.44261,1.44261 0 0 0 -0.57955,-0.07088l-0.00417,-0.02085zm-7.68837,1.86372l0.07922,1.10072a3.27715,3.27715 0 0 1 -6.54595,0.37942l-0.09173,-1.10072a0.92144,0.92144 0 0 1 0.05003,-0.33772a0.93811,0.93811 0 0 1 0.17928,-0.29603a0.89642,0.89642 0 0 1 0.27518,-0.2043a0.90893,0.90893 0 0 1 0.32938,-0.07922l4.83233,-0.26684l0.03752,0a0.77968,0.77968 0 0 1 0.32521,0.04169a0.80052,0.80052 0 0 1 0.27935,0.17095a0.77134,0.77134 0 0 1 0.18762,0.27101a0.763,0.763 0 0 1 0.06254,0.32104zm8.71821,0.60873a3.27715,3.27715 0 0 1 -6.54595,0.37942l-0.07505,-1.10072a0.88391,0.88391 0 0 1 0.21681,-0.61707a0.86307,0.86307 0 0 1 0.57955,-0.29603l0.56704,-0.03752l4.30282,-0.22515a0.86307,0.86307 0 0 1 0.90893,0.79636l0.04586,1.10072z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m202.00315,353.67936l4.83233,-0.34189a0.18762,0.18762 0 0 1 0.08339,0a0.20013,0.20013 0 0 1 0.06671,0.05003a0.22515,0.22515 0 0 1 0.04169,0.07505a0.20847,0.20847 0 0 1 0,0.08756a2.74763,2.74763 0 0 1 -0.89642,1.38424a2.70177,2.70177 0 0 1 -1.526,0.61707a2.73929,2.73929 0 0 1 -2.72262,-1.54685l0,-0.03752a0.2043,0.2043 0 0 1 -0.02919,-0.07922a0.16261,0.16261 0 0 1 0,-0.08756a0.20013,0.20013 0 0 1 0.05003,-0.06671a0.19179,0.19179 0 0 1 0.10007,-0.0542z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m180.6183,603.99335l10.50688,0l1.94711,-18.90405l-12.42898,0.04169l-0.02502,18.86236z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m180.6183,590.5929l11.81607,0l-0.83388,9.00173l-1.44261,-0.19179l-0.58789,-4.40705c-0.1501,-1.19245 -0.3002,-2.12222 -1.49681,-2.2348l-7.32563,-0.68378l-0.12925,-1.48431z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m181.69401,596.82198l0.31687,-0.29603c2.38073,-2.1931 6.49175,-2.16809 8.80577,0.10423l0.17511,0.18762a2.78933,2.78933 0 0 1 0.66293,0.93395a2.91858,2.91858 0 0 1 0.25433,1.13825l0,1.20913a6.2541,6.2541 0 0 0 0.34606,2.0847l1.08404,3.33552a7.50492,7.50492 0 0 1 0.41694,2.50164l0,0.41694a1.28417,1.28417 0 0 1 -1.37173,1.15909l-12.59992,0a1.27584,1.27584 0 0 1 -0.92144,-0.29603a1.28834,1.28834 0 0 1 -0.44613,-0.86307l0,-0.16678a8.27209,8.27209 0 0 1 0.52951,-2.87688l1.25082,-3.26464a6.54179,6.54179 0 0 0 0.45446,-2.32652l0.03336,-0.93811a3.12288,3.12288 0 0 1 0.98398,-2.05551l0.02502,0.01251z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m181.69401,596.82198l0.31687,-0.29603c2.38073,-2.1931 6.49175,-2.16809 8.80577,0.10423l0.17511,0.18762a2.78933,2.78933 0 0 1 0.66293,0.93395a2.91858,2.91858 0 0 1 0.25433,1.13825l0,1.20913a6.2541,6.2541 0 0 0 0.34606,2.0847l1.08404,3.33552a7.50492,7.50492 0 0 1 0.41694,2.50164l0,0.41694a1.28417,1.28417 0 0 1 -1.37173,1.15909l-12.59992,0a1.27584,1.27584 0 0 1 -0.92144,-0.29603a1.28834,1.28834 0 0 1 -0.44613,-0.86307l0,-0.16678a8.27209,8.27209 0 0 1 0.52951,-2.87688l1.25082,-3.26464a6.54179,6.54179 0 0 0 0.45446,-2.32652l0.03336,-0.93811a3.12288,3.12288 0 0 1 0.98398,-2.05551l0.02502,0.01251z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(307.43 -9.95)",
    d: "m178.42937,608.28366l0,0.16678a1.28834,1.28834 0 0 0 0.44613,0.86307a1.27584,1.27584 0 0 0 0.92144,0.29603l12.59575,0a1.28417,1.28417 0 0 0 1.37173,-1.15909l0,-0.41694a4.26946,4.26946 0 0 0 -0.02502,-0.56704l-15.26417,0a7.66752,7.66752 0 0 0 -0.04586,0.83388l0,-0.01668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(307.43 -9.95)",
    d: "m189.26146,595.07083a2.50164,2.50164 0 0 1 0,1.08821l-0.26684,5.67455a2.50164,2.50164 0 0 1 -2.41825,2.41408l-0.05837,0a3.29382,3.29382 0 0 1 -0.53368,-0.04586a2.50164,2.50164 0 0 1 -1.36339,-0.77134a2.53499,2.53499 0 0 1 -0.63792,-1.43427l-0.62958,-5.7496a2.41408,2.41408 0 0 1 0.33772,-1.66776c0.41694,-0.60456 1.21329,-0.80469 2.82685,-0.80469c0.00834,-0.02919 2.4391,-0.02919 2.74346,1.29668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m221.59515,590.75551l0.71714,10.98219l20.5051,1.00899l-6.81697,-7.30062c-1.30085,-0.99232 -2.0847,-3.16457 -2.35988,-4.81982l-12.04539,0.12925z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m228.58723,592.19395a4.45709,4.45709 0 0 1 4.26112,2.91858l1.31336,3.50646l4.3737,-0.41694l-2.55167,-2.73513c-1.30085,-0.99232 -2.0847,-3.16457 -2.35988,-4.81982l-12.02871,0.12925l0.10007,1.55519l6.89201,-0.13759z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m221.89534,597.08048s4.64471,3.08119 9.8648,0.41694a3.46477,3.46477 0 0 1 0.12091,-1.71362a3.26881,3.26881 0 0 1 0.92561,-1.40926c0.86307,-0.72131 2.22229,-0.95479 2.6976,-0.28769s1.6219,1.76782 2.86855,3.37721c1.7303,2.21395 4.0735,4.77396 5.88302,5.17422c3.33552,0.74215 10.03157,-2.86021 10.49437,4.67806c0,0 -6.55429,2.61421 -12.65412,1.95962a48.01896,48.01896 0 0 1 -11.64096,-2.95193l0,3.02698l-9.50623,0s-2.15558,-8.48473 0.94645,-12.27054z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(307.43 -9.95)",
    d: "m220.2526,604.55204a28.3936,28.3936 0 0 0 0.70046,4.84484l9.50623,0l0,-3.02698a48.20241,48.20241 0 0 0 11.64513,2.9561c6.08315,0.6546 12.65412,-1.96379 12.65412,-1.96379a9.65216,9.65216 0 0 0 -0.2585,-1.72196a19.82549,19.82549 0 0 1 -15.42677,1.48848c-3.48145,-1.0757 -6.29162,-1.82203 -8.75574,-2.56835c0,-0.03336 -8.16368,-0.21681 -10.06493,-0.00834z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(307.43 -9.95)",
    d: "m243.80136,602.57575s-5.24093,1.91375 -8.86414,-1.00482c-2.66008,-2.17643 -4.04015,-3.44392 -2.96027,-6.05397a2.91858,2.91858 0 0 1 0.95896,-1.25082a2.63923,2.63923 0 0 1 1.46763,-0.52117a1.71362,1.71362 0 0 1 0.74215,0.05003a1.76366,1.76366 0 0 1 0.65043,0.36691c1.69695,1.92626 5.22426,6.89201 8.00524,8.41385z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m180.39732,443.45484l49.51577,0.44613l4.7281,146.69193l-13.75901,0l-12.69582,-118.90289a1.66776,1.66776 0 0 0 -0.48782,-1.01733a1.45095,1.45095 0 0 0 -1.00066,-0.41694a1.39675,1.39675 0 0 0 -0.55453,0.10423a1.4301,1.4301 0 0 0 -0.47114,0.3127a1.58437,1.58437 0 0 0 -0.49199,1.03818l-11.93699,118.90289l-13.75901,0l0.9131,-147.1589z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    transform: "translate(307.43 -9.95)",
    d: "m230.01316,443.62162l-49.54079,0l0,5.99559l49.54079,0l0,-5.99559z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    transform: "translate(307.43 -9.95)",
    d: "m189.57,443.62162l-1.25082,0l0,5.99559l1.25082,0l0,-5.99559z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#242830",
    transform: "translate(307.43 -9.95)",
    d: "m222.65834,443.62162l-1.25082,0l0,5.99559l1.25082,0l0,-5.99559z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m210.22103,443.57576l-9.96903,0a0.41694,0.41694 0 0 0 -0.41694,0.41694l0,5.2451a0.41694,0.41694 0 0 0 0.41694,0.41694l9.96903,0a0.41694,0.41694 0 0 0 0.41694,-0.41694l0,-5.25761a0.41694,0.41694 0 0 0 -0.41694,-0.40443z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m194.79426,367.63017l7.08798,7.31729l3.63572,-6.46257l4.03598,6.46257l6.22074,-7.43404l-10.25672,0.57121l-10.72369,-0.45446z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m193.40168,348.2383a0.3127,0.3127 0 0 1 -0.19596,-0.07922a0.3002,0.3002 0 0 1 -0.1084,-0.18345l-0.07505,-0.60873a2.0847,2.0847 0 0 0 -0.52951,-1.33421a0.55036,0.55036 0 0 0 -0.21264,-0.12508a0.6129,0.6129 0 0 0 -0.24599,-0.02502a0.30437,0.30437 0 0 1 -0.21681,-0.04586a0.3127,0.3127 0 0 1 -0.12508,-0.18345a0.30437,0.30437 0 0 1 0.04586,-0.21681a0.28352,0.28352 0 0 1 0.18345,-0.12508a1.34255,1.34255 0 0 1 0.9131,0.22932c0.41694,0.3002 0.67961,0.90893 0.75883,1.71362l0.07505,0.60456a0.35857,0.35857 0 0 1 -0.06671,0.23349a0.37108,0.37108 0 0 1 -0.20013,0.14593z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(307.43 -9.95)",
    d: "m220.64452,398.3086l-15.07654,0a0.34189,0.34189 0 0 0 -0.34189,0.34189l0,9.42701a0.34189,0.34189 0 0 0 0.34189,0.34189l15.07654,0a0.34189,0.34189 0 0 0 0.34189,-0.34189l0,-9.42701a0.33772,0.33772 0 0 0 -0.34189,-0.34189z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m205.58466,398.29609l15.05987,0a0.37108,0.37108 0 0 1 0.37525,0.37525l0,1.66776l-15.80202,0l0,-1.66776a0.37942,0.37942 0 0 1 0.10423,-0.26267a0.38775,0.38775 0 0 1 0.2585,-0.11257l0.00417,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m220.94055,399.8346l0,0.12925l-15.76866,0l0,-0.12925"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m220.64452,398.3086l-15.07654,0a0.34189,0.34189 0 0 0 -0.34189,0.34189l0,9.42701a0.34189,0.34189 0 0 0 0.34189,0.34189l15.07654,0a0.34189,0.34189 0 0 0 0.34189,-0.34189l0,-9.42701a0.33772,0.33772 0 0 0 -0.34189,-0.34189z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m213.40645,395.13152l-2.0847,0l0,1.01733l2.0847,0l0,-1.01733z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(307.43 -9.95)",
    d: "m220.2526,398.3086l-15.08905,0a0.34189,0.34189 0 0 0 -0.34189,0.34189l0,9.42701a0.34189,0.34189 0 0 0 0.34189,0.34189l15.08905,0a0.34189,0.34189 0 0 0 0.34189,-0.34189l0,-9.42701a0.34189,0.34189 0 0 0 -0.34189,-0.34189z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m205.18023,398.29609l15.04736,0a0.37108,0.37108 0 0 1 0.37525,0.37525l0,1.66776l-15.80202,0l0,-1.66776a0.37942,0.37942 0 0 1 0.11257,-0.26684a0.35857,0.35857 0 0 1 0.26267,-0.1084l0.00417,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m205.18023,398.29609l15.04736,0a0.37108,0.37108 0 0 1 0.37525,0.37525l0,1.66776l-15.80202,0l0,-1.66776a0.37942,0.37942 0 0 1 0.11257,-0.26684a0.35857,0.35857 0 0 1 0.26267,-0.1084l0.00417,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m209.55809,401.56907l-3.22711,0l0,3.92757l3.22711,0l0,-3.92757z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m213.4398,398.8673l-2.32235,0a0.25433,0.25433 0 0 0 -0.25433,0.25433a0.25433,0.25433 0 0 0 0.25433,0.25433l2.32235,0a0.25433,0.25433 0 0 0 0.25433,-0.25433a0.25433,0.25433 0 0 0 -0.25433,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m219.04764,401.47317l-7.88433,0l0,0.25433l7.88433,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m213.29387,402.42797l-2.13056,0l0,0.25433l2.13056,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m213.2355,399.23421l-1.78867,0a0.38775,0.38775 0 0 1 -0.13759,-0.02919a0.37525,0.37525 0 0 1 -0.11257,-0.08756a0.3127,0.3127 0 0 1 -0.06671,-0.12091a0.38775,0.38775 0 0 1 0,-0.13759l0.23766,-1.75532l1.98046,0l0.23349,1.75532a0.27518,0.27518 0 0 1 0,0.14176a0.3127,0.3127 0 0 1 -0.06671,0.12091a0.28769,0.28769 0 0 1 -0.11674,0.08339a0.3127,0.3127 0 0 1 -0.13759,0.02919l-0.02502,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m219.04764,402.90745l-7.88433,0l0,0.25433l7.88433,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m213.99433,405.7343l-2.79767,0l0,0.25433l2.79767,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m219.05181,407.13522l-2.79767,0l0,0.23766l2.79767,0l0,-0.23766z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m218.63904,407.58134l-1.97213,0l0,0.25433l1.97213,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m219.081,406.21378l-7.88433,0l0,0.25433l7.88433,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m213.29387,403.82888l-2.13056,0l0,0.25433l2.13056,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m219.04764,404.3042l-7.88433,0l0,0.25433l7.88433,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m219.04764,404.77951l-7.88433,0l0,0.25433l7.88433,0l0,-0.25433z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m213.45231,396.06963l-2.25564,0l0,1.57603l2.25564,0l0,-1.57603z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m213.45231,396.06963l-2.25564,0l0,1.57603l2.25564,0l0,-1.57603z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(307.43 -9.95)",
    d: "m213.07707,399.21753l-1.78867,0a0.41694,0.41694 0 0 1 -0.13759,-0.02919a0.43779,0.43779 0 0 1 -0.11257,-0.08339a0.36274,0.36274 0 0 1 -0.06671,-0.12508a0.38775,0.38775 0 0 1 0,-0.13759l0.23766,-1.75532l1.97213,0l0.23349,1.75532a0.30854,0.30854 0 0 1 0,0.13759a0.36274,0.36274 0 0 1 -0.06671,0.12508a0.37525,0.37525 0 0 1 -0.11257,0.08339a0.3127,0.3127 0 0 1 -0.13759,0.02919l-0.02085,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#dadddf",
    transform: "translate(307.43 -9.95)",
    d: "m213.26469,395.13152l-2.0847,0l0,1.03401l2.0847,0l0,-1.03401z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m213.26052,396.06963l-2.25564,0l0,1.57603l2.25564,0l0,-1.57603z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m213.26052,396.06963l-2.25564,0l0,1.57603l2.25564,0l0,-1.57603z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m206.46857,406.12205l-0.11674,0l0,0.83388l0.11674,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m206.70206,406.12205l-0.17511,0l0,0.83388l0.17511,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m206.79795,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m206.91053,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.08564,406.12205l-0.11674,0l0,0.83388l0.11674,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.30245,406.12205l-0.17511,0l0,0.83388l0.17511,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.39835,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.51509,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m208.00291,406.92675l0.13342,0l0,-0.83388l-0.11674,0l-0.01668,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.78193,406.92675l0.17511,0l0,-0.83388l-0.17511,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.69437,406.92675l0.0542,0l0,-0.83388l-0.0542,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.57763,406.92675l0.0542,0l0,-0.83388l-0.0542,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m208.29894,406.12205l-0.11674,0l0,0.83388l0.11674,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m208.51574,406.12205l-0.17511,0l0,0.83388l0.17511,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m208.61164,406.12205l-0.05837,0l0,0.83388l0.0542,0l0.00417,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m208.72421,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m208.89933,406.12205l-0.11674,0l0,0.83388l0.11674,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m209.11614,406.12205l-0.17511,0l0,0.83388l0.17511,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m209.21203,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m209.32878,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m209.50806,406.92675l0.0542,0l0,-0.83388l-0.0542,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m209.38715,406.92675l0.0542,0l0,-0.83388l-0.0542,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m206.46857,406.12205l-0.11674,0l0,0.83388l0.11674,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m206.70206,406.12205l-0.17511,0l0,0.83388l0.17511,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m206.79795,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m206.91053,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m207.08564,406.12205l-0.11674,0l0,0.83388l0.11674,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m207.30245,406.12205l-0.17511,0l0,0.83388l0.17511,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m207.39835,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m207.51509,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m208.00291,406.92675l0.13342,0l0,-0.83388l-0.11674,0l-0.01668,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m207.78193,406.92675l0.17511,0l0,-0.83388l-0.17511,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m207.69437,406.92675l0.0542,0l0,-0.83388l-0.0542,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m207.57763,406.92675l0.0542,0l0,-0.83388l-0.0542,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m208.29894,406.12205l-0.11674,0l0,0.83388l0.11674,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m208.51574,406.12205l-0.17511,0l0,0.83388l0.17511,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m208.61164,406.12205l-0.05837,0l0,0.83388l0.0542,0l0.00417,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m208.72421,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m208.89933,406.12205l-0.11674,0l0,0.83388l0.11674,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m209.11614,406.12205l-0.17511,0l0,0.83388l0.17511,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m209.21203,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m209.32878,406.12205l-0.0542,0l0,0.83388l0.0542,0l0,-0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m209.50806,406.92675l0.0542,0l0,-0.83388l-0.0542,0l0,0.83388z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m209.38715,406.92675l0.0542,0l0,-0.83388l-0.0542,0l0,0.83388z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m209.2579,404.03735l-0.72964,-0.14176l-0.27518,0.32938l-0.06671,-0.10423l0,0.02919l0.1084,1.31753l0.83388,0l0.02919,-0.74215l0.12508,0.32521l0.15427,0.41694l0.17511,0l0,-1.29251a0.50033,0.50033 0 0 0 -0.3544,-0.13759z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m208.02793,403.58706a0.31687,0.31687 0 0 1 -0.12508,0a0.33772,0.33772 0 0 0 0.12925,0l0.03336,0a0.41694,0.41694 0 0 0 0.30437,-0.31687l0,0a0.37108,0.37108 0 0 1 -0.11674,0.21264a0.38775,0.38775 0 0 1 -0.22515,0.10423z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m208.06128,403.94146l0.36691,-0.20847l-0.02919,-0.20847a0.41694,0.41694 0 0 1 -0.28352,0.07922a0.30854,0.30854 0 0 1 -0.08756,0a0.36274,0.36274 0 0 1 -0.20013,-0.04586a0.35023,0.35023 0 0 1 -0.14593,-0.14593l0,0c0,-0.03336 -0.03752,-0.07088 -0.0542,-0.10423l0,0.41694l0.43362,0.21681z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m207.882,403.56621a0.45863,0.45863 0 0 1 -0.17511,-0.15844l0,0c-0.02085,-0.03336 -0.03752,-0.07088 -0.0542,-0.10423a0.95896,0.95896 0 0 1 -0.05003,-0.14176l-0.02085,-0.18345l0,0a0.02502,0.02502 0 0 0 0,0l0,-0.08339a0.03752,0.03752 0 0 0 0.02502,0a0.04169,0.04169 0 0 0 0,-0.02919l0,-0.15844a0.07922,0.07922 0 0 1 0,-0.0542a0.05837,0.05837 0 0 1 0.05003,-0.02502l0.50033,-0.04169l0.08756,-0.02919l0.02502,0.24599c0,0.0542 0.02502,0.0542 0.06254,0.0542l0,0.27101a1.25082,1.25082 0 0 1 -0.03336,0.17095a0.37108,0.37108 0 0 1 -0.11674,0.21681a0.38775,0.38775 0 0 1 -0.22515,0.10423a0.31687,0.31687 0 0 1 -0.07505,-0.0542z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m208.03209,402.94497l0,0.05003a0.13759,0.13759 0 0 0 0,0.0542a0.18345,0.18345 0 0 0 0.03336,0.04586a0.19596,0.19596 0 0 0 0.05003,0.02919l0.0542,0a0.13342,0.13342 0 0 0 0.05837,0l0.04586,-0.03752a0.0959,0.0959 0 0 0 0.02502,-0.05003a0.12508,0.12508 0 0 0 0,-0.0542l0,-0.04586a0.03752,0.03752 0 0 0 0,-0.02502a0.04586,0.04586 0 0 0 -0.02919,0l-0.23349,0l0,0a0.03336,0.03336 0 0 0 0,0s0,0 0,0.02085l-0.00417,0.01251zm0.12925,0.08339a0.07922,0.07922 0 0 1 -0.03336,0a0.0542,0.0542 0 0 1 0,-0.03336s0,0 0,0a0.02085,0.02085 0 0 1 0,0l0,0l0.03336,0l0,0l0,0l0,0.03336l0,0l0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m207.80695,403.15344l0.0542,0a0.11674,0.11674 0 0 0 0.04586,-0.03336a0.10007,0.10007 0 0 0 0.02919,-0.05003a0.12508,0.12508 0 0 0 0,-0.0542l0,-0.05003a0.03752,0.03752 0 0 0 0,-0.02919l-0.02502,0l-0.21264,0a0.02919,0.02919 0 0 0 -0.02502,0a0.03752,0.03752 0 0 0 0,0.02919l0,0.05003a0.16261,0.16261 0 0 0 0,0.05837a0.11257,0.11257 0 0 0 0.07922,0.07922a0.14593,0.14593 0 0 0 0.05837,0l-0.00417,0zm0,-0.10007a0.07922,0.07922 0 0 1 -0.03336,0a0.0542,0.0542 0 0 1 0,-0.03336s0,0 0,0a0.02085,0.02085 0 0 1 0,0l0,0l0,0a0.04169,0.04169 0 0 1 0.04169,0.04169a0.0542,0.0542 0 0 1 0,0.02502l-0.02085,0.02085l0.01251,-0.0542z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m208.40734,403.52452l-0.03752,-0.25433l0.03336,0.25016l0.00417,0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m208.06545,403.58289l-0.03336,0a0.33772,0.33772 0 0 1 -0.12925,0a0.45863,0.45863 0 0 1 -0.17511,-0.15844l0,0a0.35023,0.35023 0 0 0 0.14593,0.14593a0.37108,0.37108 0 0 0 0.20013,0.04586l0.08756,0a0.41694,0.41694 0 0 0 0.28352,-0.07922l-0.03336,-0.25016a0.41694,0.41694 0 0 1 -0.12925,0.20013a0.44613,0.44613 0 0 1 -0.21681,0.0959z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m208.06545,403.58289l-0.03336,0a0.33772,0.33772 0 0 1 -0.12925,0a0.45863,0.45863 0 0 1 -0.17511,-0.15844l0,0a0.35023,0.35023 0 0 0 0.14593,0.14593a0.37108,0.37108 0 0 0 0.20013,0.04586l0.08756,0a0.41694,0.41694 0 0 0 0.28352,-0.07922l-0.03336,-0.25016a0.41694,0.41694 0 0 1 -0.12925,0.20013a0.44613,0.44613 0 0 1 -0.21681,0.0959z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m208.28226,402.51135l0.02502,0.24599c0,0.03336 0.02502,0.05003 0.06254,0.0542l0,-0.06671l0.06671,0l0,0.04169a0.09173,0.09173 0 0 1 0.06671,0a0.37108,0.37108 0 0 0 0,-0.28352c-0.03336,-0.08339 -0.08339,-0.1084 -0.12508,-0.1084a0.19179,0.19179 0 0 1 -0.03752,0.06254a0.2043,0.2043 0 0 1 -0.05837,0.04586l0,0.00834z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m207.53177,402.86158l0,-0.0542l0.06254,0l0,0.05837a0.03752,0.03752 0 0 0 0.02502,0a0.04169,0.04169 0 0 0 0,-0.02919l0,-0.15844a0.07922,0.07922 0 0 1 0.02085,-0.0542a0.05837,0.05837 0 0 1 0.05003,-0.02502l0.50033,-0.04169l0.08756,-0.02919a0.37942,0.37942 0 0 0 0.06671,-0.04586a0.23349,0.23349 0 0 0 0.03752,-0.07088a0.25016,0.25016 0 0 0 0,-0.07922a0.18345,0.18345 0 0 0 -0.06254,-0.12508a0.17928,0.17928 0 0 0 -0.12925,-0.05003l-0.09173,0a0.99232,0.99232 0 0 0 -0.49199,0.06254a0.4628,0.4628 0 0 0 -0.22515,0.29186a0.47948,0.47948 0 0 0 0,0.18762a0.52117,0.52117 0 0 0 0.07088,0.17928a0.07088,0.07088 0 0 1 0.04169,0l0.03752,0l0,-0.01668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m207.57346,402.97416l-0.02502,0l0,-0.0959a0.06671,0.06671 0 0 0 -0.03752,0a0.07088,0.07088 0 0 0 -0.04169,0a0.1501,0.1501 0 0 0 -0.03336,0.0959a0.17511,0.17511 0 0 0 0.02085,0.10007a0.19179,0.19179 0 0 0 0.07088,0.07088a0.20847,0.20847 0 0 0 0.10007,0.02502l0,0l-0.0542,-0.19596zm-0.05003,0.07088l0,-0.02919a0.07088,0.07088 0 0 0 0,-0.05837l-0.02085,0a0.05837,0.05837 0 0 1 0.03752,0a0.11257,0.11257 0 0 1 0.02919,0.03336a0.12508,0.12508 0 0 1 0,0.04169l0,0.02919l0,0l0,0s0,0 0,0a0.04586,0.04586 0 0 1 0,-0.02085l-0.04586,0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m208.42402,402.89077l0,-0.10423a0.10007,0.10007 0 0 1 0.04169,0a0.05837,0.05837 0 0 1 0.04586,0a0.15427,0.15427 0 0 1 0.05003,0.08339a0.16261,0.16261 0 0 1 0,0.10007a0.21681,0.21681 0 0 1 -0.05837,0.07922a0.2043,0.2043 0 0 1 -0.0959,0.03336l0,-0.18762l0.01668,-0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m207.52343,402.80738l0,0.1501l0.02502,0l0,0a0.03336,0.03336 0 0 0 0,0l0,-0.17095l-0.02502,0.02085z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m208.42819,402.89077l0,-0.14176l-0.06671,0l0,0.1501l0.06671,-0.00834z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m207.82362,402.96582l0,0l0,0l0,0s0,0 0,0a0.04169,0.04169 0 0 0 0,0.03336a0.06254,0.06254 0 0 0 0.02919,0s0.02502,0 0.02919,0a0.04586,0.04586 0 0 0 0,-0.02919a0.03752,0.03752 0 0 0 0,-0.02919a0.03336,0.03336 0 0 0 -0.02919,0l-0.02919,0.02502z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m208.13633,402.9408l0.03336,0l0,0s0,0 0,0l0,0.03336l0,0s0,0 0,0l0,0a0.07922,0.07922 0 0 1 -0.03336,0a0.0542,0.0542 0 0 1 0,-0.03336s0,0 0,0l0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#21252b",
    transform: "translate(307.43 -9.95)",
    d: "m207.80695,403.17846l0.06671,0l0.0542,-0.04169a0.23766,0.23766 0 0 0 0.03336,-0.0542a0.18345,0.18345 0 0 0 0,-0.06671l0,-0.05003a0.05837,0.05837 0 0 0 0,-0.03752l0.06671,0a0.07088,0.07088 0 0 0 0,0.04169l0,0.04586a0.1084,0.1084 0 0 0 0,0.06254a0.12508,0.12508 0 0 0 0.03752,0.0542a0.17511,0.17511 0 0 0 0.05837,0.03752l0.06671,0l0.06671,0a0.17095,0.17095 0 0 0 0.0542,-0.04169a0.23766,0.23766 0 0 0 0.03336,-0.0542a0.19596,0.19596 0 0 0 0,-0.06671l0,-0.05003a0.0542,0.0542 0 0 0 0,-0.02502a0.12091,0.12091 0 0 0 -0.03752,-0.03752l-0.58789,0a0.06671,0.06671 0 0 0 -0.04586,0.02085a0.08756,0.08756 0 0 0 0,0.04586l0,0.05003a0.16678,0.16678 0 0 0 0.03752,0.12508a0.18762,0.18762 0 0 0 0.11674,0.06671l-0.02085,-0.02502zm0.26267,-0.27518l0.21681,0a0.03752,0.03752 0 0 1 0.02919,0a0.03752,0.03752 0 0 1 0,0.02502l0,0.04586a0.12508,0.12508 0 0 1 0,0.0542a0.0959,0.0959 0 0 1 -0.02502,0.05003a0.12925,0.12925 0 0 1 -0.04586,0.03752a0.12925,0.12925 0 0 1 -0.0542,0a0.13342,0.13342 0 0 1 -0.05837,0l-0.05003,-0.02919a0.18345,0.18345 0 0 1 -0.03336,-0.04586a0.13759,0.13759 0 0 1 0,-0.0542l0,-0.05003s0,0 0,-0.02085a0.03336,0.03336 0 0 1 0,0l0,0l0.02085,-0.01251zm-0.41694,0.06254a0.03752,0.03752 0 0 1 0,-0.02919a0.03752,0.03752 0 0 1 0.02502,0l0.22932,0l0,0l0,0a0.02502,0.02502 0 0 1 0,0l0,0.05003a0.12508,0.12508 0 0 1 0,0.0542a0.10007,0.10007 0 0 1 -0.02919,0.05003l-0.04586,0.03336l-0.0542,0l-0.0542,0a0.14593,0.14593 0 0 1 -0.05003,-0.02919a0.11674,0.11674 0 0 1 -0.03336,-0.04586a0.13759,0.13759 0 0 1 0,-0.0542l0.01251,-0.02919z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m208.13633,403.27018l-0.21681,0a0.12508,0.12508 0 0 0 0.04586,0.05837a0.10423,0.10423 0 0 0 0.07088,0.02502a0.0959,0.0959 0 0 0 0.06671,-0.02502a0.12508,0.12508 0 0 0 0.04586,-0.05837l-0.01251,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m208.19053,404.10823l0,0.02085l0.06671,0.10423l0.27518,-0.32938l-0.27518,0.27518l-0.06671,-0.07088z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m208.19053,404.10823l0,0.02085l0.06671,0.10423l0.27518,-0.32938l-0.27518,0.27518l-0.06671,-0.07088z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.94454,404.10823l-0.04586,0.07088l-0.31687,-0.27101l0.31687,0.32521l0.05837,-0.10423l0,-0.02085l-0.01251,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m207.94454,404.10823l-0.04586,0.07088l-0.31687,-0.27101l0.31687,0.32521l0.05837,-0.10423l0,-0.02085l-0.01251,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m207.49841,402.92412l0,0a0.07088,0.07088 0 0 1 0,0.05837l0,0a0.0959,0.0959 0 0 0 0,-0.05837z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m207.49841,402.92412l0,0a0.07088,0.07088 0 0 1 0,0.05837l0,0a0.0959,0.0959 0 0 0 0,-0.05837z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(307.43 -9.95)",
    d: "m208.13633,404.17911l-0.09173,0.0542l-0.07922,-0.0542l0,-0.02502l0,0l-0.07922,1.34255l0.36274,0l-0.11257,-1.31753z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(307.43 -9.95)",
    d: "m208.06962,404.2083a0.35857,0.35857 0 0 1 -0.08339,-0.0542l0,0.02502l0.07922,0.0542l0.09173,-0.0542l0,-0.02919a0.25016,0.25016 0 0 1 -0.08756,0.05837z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m208.06962,404.2083a0.35857,0.35857 0 0 1 -0.08339,-0.0542l0,0.02502l0.07922,0.0542l0.09173,-0.0542l0,-0.02919a0.25016,0.25016 0 0 1 -0.08756,0.05837z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f4f4f4",
    transform: "translate(307.43 -9.95)",
    d: "m208.06128,403.94146l-0.11674,0.17928l0,0.02085l0.02502,0.02502a0.35857,0.35857 0 0 0 0.08339,0.0542a0.20013,0.20013 0 0 0 0.08339,-0.05837l0,0l0,-0.02085l-0.07505,-0.20013z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fb9c9c",
    transform: "translate(307.43 -9.95)",
    d: "m208.44487,402.93663l0,0a0.08339,0.08339 0 0 1 0,-0.02919a0.06254,0.06254 0 0 1 0,-0.02919l-0.03752,0a0.10007,0.10007 0 0 0 0.03752,0.06254l0,-0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m208.44487,402.93663l0,0a0.08339,0.08339 0 0 1 0,-0.02919a0.06254,0.06254 0 0 1 0,-0.02919l-0.03752,0a0.10007,0.10007 0 0 0 0.03752,0.06254l0,-0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m207.89867,404.17911l0.04586,-0.07088l0.11674,-0.17928l-0.41694,-0.19596l0,0l-0.06671,0.17095l0,0l0.32104,0.27518z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m206.96473,404.77534l-0.02085,0l-0.12925,0.72131l0.15427,0l0,-0.72131l-0.00417,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m206.96473,404.77534l-0.02085,0l-0.12925,0.72131l0.15427,0l0,-0.72131l-0.00417,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m209.10363,404.75449l-0.02919,0.74215l0.15427,0l0,-0.41694l-0.12508,-0.32521z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m209.10363,404.75449l-0.02919,0.74215l0.15427,0l0,-0.41694l-0.12508,-0.32521z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m208.06128,403.92895l0.12925,0.17928l0.05003,0.07088l0.27518,-0.27518l0,0l-0.0959,-0.16678l0,0l-0.35857,0.19179z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fff",
    transform: "translate(307.43 -9.95)",
    d: "m220.59449,399.83877l-15.77283,0l0,0.12925l15.77283,0l0,-0.12925z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m214.33206,346.67894a0.31687,0.31687 0 0 0 0.19596,-0.10007a0.28769,0.28769 0 0 0 0.07088,-0.2043l0,-0.60873a1.75115,1.75115 0 0 1 0.02919,-0.72131a1.77616,1.77616 0 0 1 0.3127,-0.65043a0.58789,0.58789 0 0 1 0.20013,-0.16678a0.54619,0.54619 0 0 1 0.25433,-0.06254a0.35023,0.35023 0 0 0 0.11257,0a0.31687,0.31687 0 0 0 0.0959,-0.0542a0.34606,0.34606 0 0 0 0.06671,-0.08756a0.32104,0.32104 0 0 0 0.02919,-0.1084a0.3127,0.3127 0 0 0 0,-0.1084a0.27518,0.27518 0 0 0 -0.14176,-0.16261a0.24599,0.24599 0 0 0 -0.1084,-0.02919a1.14658,1.14658 0 0 0 -0.45446,0.10423a1.16743,1.16743 0 0 0 -0.37942,0.27518c-0.37942,0.37942 -0.53368,0.98815 -0.49616,1.8262l0,0.60039c-0.09173,0.14176 0.02085,0.2585 0.21264,0.2585z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m196.04508,363.64423l-1.45095,3.83168l7.26309,6.2541l3.63572,-5.64953l-9.44786,-4.43624z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m195.17367,408.5278l-0.57121,-1.27584l-4.84484,1.61356l-8.88082,1.61356l0.41694,-23.41534a0.41694,0.41694 0 0 0 -0.41694,-0.41694a0.41694,0.41694 0 0 0 -0.29603,0.12091a0.41694,0.41694 0 0 0 -0.12091,0.29603l-4.4279,24.62863c-6.18739,2.19727 -8.71404,3.39806 -8.71404,3.39806l10.84043,-2.57252l-0.1084,0.38358l17.12372,-4.3737z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m233.70308,415.15297l-1.96379,0.97564l0,-22.19371l-2.82268,-7.26726l-1.93877,50.6832c-0.03752,0.99232 0,1.9888 0.02502,2.98112a3.2563,3.2563 0 0 1 -2.12639,3.26047l5.03663,0.17095a2.96861,2.96861 0 0 0 1.8262,-2.74346l-0.15427,-11.91614l3.27715,-1.37173l-1.15909,-12.57907z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m217.20894,424.19639l0.80469,-0.80469l9.68968,-6.46257l-0.64626,12.4665l-9.68968,2.42242l-0.15844,-7.62166z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m213.77753,363.43993l2.21812,3.83585l-6.4584,6.4584l-4.03598,-5.64953l8.27626,-4.64471z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fa9b9b",
    transform: "translate(307.43 -9.95)",
    d: "m197.14163,417.48783l1.49681,-1.36339c3.46477,-3.47311 2.83519,-5.00328 2.83519,-5.00328l3.75246,-0.7088a0.66293,0.66293 0 0 0 0.30854,-0.14593a0.67961,0.67961 0 0 0 0.20013,-0.27101a0.70463,0.70463 0 0 0 0.05003,-0.32104a0.68378,0.68378 0 0 0 -0.1084,-0.3002a0.7088,0.7088 0 0 0 -0.23766,-0.22098a0.68378,0.68378 0 0 0 -0.3127,-0.07922l-3.98594,-0.22098l5.87051,0.31687a0.83388,0.83388 0 0 0 0.38775,-0.09173a0.85473,0.85473 0 0 0 0.3002,-0.2585a0.75883,0.75883 0 0 0 0.13759,-0.36274a0.73798,0.73798 0 0 0 -0.05003,-0.37942a0.763,0.763 0 0 0 -0.22515,-0.3127a0.77551,0.77551 0 0 0 -0.35023,-0.16261l-4.6739,-0.93811l6.11651,1.21329a0.87557,0.87557 0 0 0 0.83388,-0.34606a0.83388,0.83388 0 0 0 0.15844,-0.37108a0.8714,0.8714 0 0 0 -0.03336,-0.41694a0.83388,0.83388 0 0 0 -0.22098,-0.33772a0.78802,0.78802 0 0 0 -0.35023,-0.19596l-4.94491,-1.4718l6.34165,0.35023a0.90059,0.90059 0 0 0 0.33355,-0.02919a0.88391,0.88391 0 0 0 0.29603,-0.15844a0.98398,0.98398 0 0 0 0.20847,-0.26267a0.85473,0.85473 0 0 0 0.08756,-0.32104a0.8714,0.8714 0 0 0 -0.72131,-0.95896l-7.62166,-1.10072a3.2021,3.2021 0 0 0 -1.39258,0.04586a2.57252,2.57252 0 0 0 -1.15492,0.72548l-3.78581,3.17291l-1.66776,5.80797l2.12222,5.47859z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m201.09839,409.18239l4.58634,0.21264a0.6546,0.6546 0 0 0 -0.22932,-0.3002a0.62958,0.62958 0 0 0 -0.3544,-0.11674l-0.80469,-0.04586l-3.15206,-0.1501a0.24183,0.24183 0 0 0 -0.14176,0.05837a0.25016,0.25016 0 0 0 -0.07505,0.13759c-0.00417,0.12091 0.06254,0.22098 0.17095,0.2043z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m207.68603,408.06916l0.0542,0a0.75049,0.75049 0 0 0 -0.17511,-0.29186a0.71714,0.71714 0 0 0 -0.28352,-0.18762l-2.28483,-0.47948l-2.50164,-0.50033l2.15558,0.44196l-2.12639,-0.44613a0.17511,0.17511 0 0 0 -0.14176,0.02502a0.18762,0.18762 0 0 0 -0.08339,0.11674a0.21264,0.21264 0 0 0 0.02502,0.14176a0.19596,0.19596 0 0 0 0.11674,0.08339l5.2451,1.09655z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m211.12162,404.80452l-8.23873,-0.39192l1.10906,0.3127l0.17511,0l-0.09173,-0.02502l6.34165,0.35023a0.8589,0.8589 0 0 0 0.38358,-0.04169a0.83388,0.83388 0 0 0 0.32104,-0.2043z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#fc9d9d",
    transform: "translate(307.43 -9.95)",
    d: "m219.63553,423.21658l6.12485,6.61267s-3.23128,1.29668 -4.22777,1.8804c-7.47573,4.39038 -9.70219,3.98178 -9.70219,3.98178a0.79219,0.79219 0 0 1 -0.75466,-0.05003a1.19245,1.19245 0 0 1 -0.49199,-1.12157a0.74215,0.74215 0 0 1 0.0959,-0.30854a0.75883,0.75883 0 0 1 0.21264,-0.23349l0.83388,-0.45863l-0.57121,0.32521a1.00899,1.00899 0 0 1 -0.45029,0.13342a1.09655,1.09655 0 0 1 -0.4628,-0.07922a1.04652,1.04652 0 0 1 -0.59205,-0.69629a1.12574,1.12574 0 0 1 0.09173,-0.70046a1.10906,1.10906 0 0 1 0.48782,-0.50033l0.39192,-0.21681l-0.41694,0.2585a1.09238,1.09238 0 0 1 -0.41694,0.14176a1.0632,1.0632 0 0 1 -0.41694,-0.02919a1.01733,1.01733 0 0 1 -0.40026,-0.18345a1.0632,1.0632 0 0 1 -0.27518,-0.33355a1.09655,1.09655 0 0 1 -0.12091,-0.78385a1.0632,1.0632 0 0 1 0.41694,-0.6546l0.45863,-0.32104l-0.41694,0.30437a0.95479,0.95479 0 0 1 -0.36691,0.15427a0.99649,0.99649 0 0 1 -0.41694,0a0.98398,0.98398 0 0 1 -0.36274,-0.16261a0.95479,0.95479 0 0 1 -0.26684,-0.29603a1.00066,1.00066 0 0 1 0.31687,-1.28417l4.84901,-2.289l-1.7303,-3.57734a1.4718,1.4718 0 0 1 -0.1501,-0.57955a1.43427,1.43427 0 0 1 0.09173,-0.59205a1.45512,1.45512 0 0 1 0.31687,-0.5045a1.42593,1.42593 0 0 1 0.49616,-0.33355a0.34606,0.34606 0 0 1 0.18345,-0.02085a0.35023,0.35023 0 0 1 0.16261,0.07922l1.73447,2.4391a1.10072,1.10072 0 0 0 0.49616,0.38358l2.85604,1.08404l2.39323,-1.46763z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m210.96735,433.90275l0.5045,-0.26267l0.17511,-0.24599s-1.3217,0.47531 -1.78033,0.2043a1.04652,1.04652 0 0 0 1.12157,0.28769l-0.02085,0.01668z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m210.04591,432.10157l0.5587,-0.16678l0.3002,-0.3544s-1.81786,0.65043 -2.12639,0.17095a1.05903,1.05903 0 0 0 0.57121,0.39609a1.07987,1.07987 0 0 0 0.69629,-0.04586z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m209.90415,432.23499l0.11257,-0.10423a0.6671,0.6671 0 0 0 -0.11257,0.10423z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m207.71939,429.96267a0.97147,0.97147 0 0 0 1.33004,0.22098l-0.02502,0a1.18411,1.18411 0 0 0 -0.22098,0.21264l0.57121,-0.45863l0.41694,-0.21264a2.37656,2.37656 0 0 1 -2.0847,0.23766l0.01251,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.15,
    transform: "translate(307.43 -9.95)",
    d: "m210.63797,435.07435a1.20496,1.20496 0 0 0 0.41694,0.5587a0.78385,0.78385 0 0 0 0.37108,0.12091a0.80886,0.80886 0 0 0 0.38358,-0.07088s2.22646,0.41694 9.70219,-3.98178c0.86307,-0.50867 3.4064,-1.54685 4.06516,-1.81786l-0.88808,-1.08404l-3.96927,2.57669c-8.21788,4.34868 -9.95652,3.74412 -10.0816,3.69826z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m231.58502,429.0871l20.01311,-8.37215a5.83716,5.83716 0 0 0 3.19376,-7.4257l-3.33552,-8.82662l-27.56389,16.30235l-5.83716,3.02698l4.04015,8.88499l9.53124,-3.57734l-0.04169,-0.01251z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "current",
    transform: "translate(307.43 -9.95)",
    d: "m198.63844,418.14243l-3.64822,-10.09411l-4.84067,1.61773l-31.01615,7.35899l-1.4718,6.46257a7.05462,7.05462 0 0 0 1.88874,6.44172l0,0a7.04628,7.04628 0 0 0 7.72589,1.50515l11.77021,-4.97826l0,0.07088l19.592,-8.38466z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    opacity: 0.2,
    strokeWidth: "0.97px",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "translate(307.43 -9.95)",
    d: "m190.96675,410.0663l3.1062,8.90583"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    opacity: 0.2,
    strokeWidth: "0.97px",
    strokeMiterlimit: 10,
    fill: "none",
    transform: "translate(307.43 -9.95)",
    d: "m222.72922,421.99912l4.1694,8.45971"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m237.83078,410.74592s5.75377,-2.25147 7.50492,-2.67675l-7.06296,4.01513l-0.44196,-1.33838z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m249.90953,417.33356l-28.84807,13.12527l1.00899,2.21812l9.53124,-3.57734l20.01311,-8.37215a5.83716,5.83716 0 0 0 3.19376,-7.4257l-1.2258,-3.22294c0.79219,6.46674 -3.67324,7.25475 -3.67324,7.25475z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.2,
    transform: "translate(307.43 -9.95)",
    d: "m157.49482,424.90936a7.04211,7.04211 0 0 0 9.78141,6.50843l11.76187,-4.96158l0,0.07088l19.59617,-8.39717l-0.72548,-2.00131l-28.74383,11.29907c-10.96552,2.92275 -11.64096,-1.63023 -11.67015,-2.51832z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m224.81392,449.62972l5.83716,140.99653l3.90256,-0.10423l-4.4279,-140.8923l-5.31181,0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    opacity: 0.3,
    transform: "translate(307.43 -9.95)",
    d: "m200.3604,472.97835l-11.03223,117.54367l3.91923,0l11.93282,-118.82784a1.62607,1.62607 0 0 1 0.49199,-1.03818a1.38841,1.38841 0 0 1 0.47531,-0.3127a1.40926,1.40926 0 0 1 0.55453,-0.10423a1.14242,1.14242 0 0 1 0.37525,0.06254l0.03752,-0.5045a2.9978,2.9978 0 0 0 -0.59622,-0.36274a4.28614,4.28614 0 0 0 -2.02216,-0.41694a4.38621,4.38621 0 0 0 -1.98463,0.57121a4.35702,4.35702 0 0 0 -2.15141,3.38555l0,0.00417z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#b2b6bb",
    transform: "translate(307.43 -9.95)",
    d: "m486.55205,610.71442l-480.4856,0a0.64209,0.64209 0 0 1 -0.27935,-0.03752a0.7088,0.7088 0 0 1 -0.24183,-0.14176a0.79219,0.79219 0 0 1 -0.16261,-0.22932a0.7088,0.7088 0 0 1 -0.05837,-0.27518a0.71297,0.71297 0 0 1 0.05837,-0.27935a0.79219,0.79219 0 0 1 0.16261,-0.22932a0.7088,0.7088 0 0 1 0.24183,-0.14176a0.64209,0.64209 0 0 1 0.27935,-0.03752l480.4856,0a0.64209,0.64209 0 0 1 0.27935,0.03752a0.7088,0.7088 0 0 1 0.24183,0.14176a0.72131,0.72131 0 0 1 0.16261,0.22932a0.68795,0.68795 0 0 1 0,0.55453a0.72131,0.72131 0 0 1 -0.16261,0.22932a0.7088,0.7088 0 0 1 -0.24183,0.14176a0.64209,0.64209 0 0 1 -0.27935,0.03752z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitekCheck);
export default __webpack_public_path__ + "static/media/MitekCheck.4a079cb0b8e930a650c46110f4b31cd0.svg";
export { ForwardRef as ReactComponent };